import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import axios from 'axios';
import Notifications from 'vue-notification';

Vue.use(Notifications);

Vue.config.productionTip = false

const base = axios.create({
  baseURL: 'https://tavernedesspores.fr/server/',
  crossDomain: true
});

Vue.prototype.$http = base;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
